import { Divider } from '@mui/material';
import { styled } from '@mui/material/styles';

import { containerSmallWidth, Theme, px, rem } from '../../theme';
import { Heading } from '../Heading';
import { Paragraph } from '../Paragraph';

export const StyledHeading = styled(Heading)`
    ${({ theme }: { theme: Theme }) => `
        margin-right: ${theme.tggSpacing(0, 0)};
        margin-left: ${theme.tggSpacing(0, 0)};
        ${theme.breakpoints.up('desktop')} {
            text-align: center;
        }
	`}
`;

export const StyledDescription = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => `
        ${theme.breakpoints.up('desktop')} {
            max-width: ${containerSmallWidth}rem;
            margin: ${theme.tggSpacing([0, 'auto'], [0, 'auto'])};
            text-align: center;
        }
	`}
`;

export const StyledPinoSectionHeader = styled('section')`
    ${({ theme }: { theme: Theme }) => `
        padding: ${theme.tggSpacing(px(30), 7.5)};
        margin: ${theme.tggSpacing(0, 0)};
	`}
`;

export const StyledOptionButton = styled('div')<{
    isrejoin?: boolean;
}>`
    ${({ theme, isrejoin }: { theme: Theme; isrejoin?: boolean }) => `
        display: flex;
        flex-direction: ${isrejoin ? 'column' : 'row'};
        gap: 1rem;
        justify-content: center;
        max-width: ${isrejoin && '50%'};
        margin: ${
            isrejoin
                ? theme.tggSpacing([rem(3), 'auto'], [12, 'auto'])
                : theme.tggSpacing(
                      [px(30), px(30), px(40), px(30)],
                      [7.5, 7.5, 10, 7.5],
                  )
        };
        ${theme.breakpoints.down('desktop')} {
            max-width: ${isrejoin && '100%'};
        }
	`}
`;

interface StyledProductOptionWrapperProperties {
    $visible: boolean;
    $isMBTOptimizationV2orV3?: boolean;
}

export const StyledProductOptionWrapper = styled(
    'section',
)<StyledProductOptionWrapperProperties>`
    ${({
        theme,
        $visible,
        $isMBTOptimizationV2orV3,
    }: StyledProductOptionWrapperProperties & { theme: Theme }) => `
        width: 100%;
        visibility: ${$visible ? 'visible' : 'hidden'};

        .pino-option-offpeak {
            border-color: ${
                $isMBTOptimizationV2orV3 &&
                theme.palette.mbtOptimizationPino.offPeak
            };

            hr {
                background-color: ${
                    $isMBTOptimizationV2orV3 &&
                    theme.palette.mbtOptimizationPino.offPeak
                };
            }
        }

        .pino-options-offpeak__heading {
            color: ${
                $isMBTOptimizationV2orV3 &&
                theme.palette.mbtOptimizationPino.offPeak
            };
        }
	`}
`;

export const StyledDivider = styled(Divider)`
    ${({ theme }: { theme: Theme }) => `
        margin-top: ${theme.tggSpacing(rem(3), 12)};
        margin-right: ${theme.tggSpacing(rem(3), 12)};
        margin-left: ${theme.tggSpacing(rem(3), 12)};

        ${theme.breakpoints.up('desktop')} {
            margin-top: ${theme.tggSpacing(rem(4), 16)};
        }
	`}
`;
